import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: { flex: 1 },
    centerContainer: { flex: 1, justifyContent: 'center', alignItems: 'center' },
    header: { padding: 20, paddingBottom: 15, borderBottomWidth: 1 },
    title: { fontSize: 24, fontWeight: 'bold', marginBottom: 8 },
    participantCount: { fontSize: 14, marginTop: 8 },
    championBanner: {
      marginTop: 10,
      paddingHorizontal: 10,
      paddingVertical: 6,
      borderRadius: 6,
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
      alignSelf: 'flex-start',
    },
    championLabel: { fontSize: 11, fontWeight: '600', color: '#B8860B', letterSpacing: 0.3 },
    championName: { fontSize: 14, fontWeight: '600' },
    roleBadge: {
      marginTop: 10,
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 12,
      alignSelf: 'flex-start',
      flexDirection: 'row',
      alignItems: 'center',
    },
    roleBadgeText: { fontSize: 12, fontWeight: '600', color: '#fff' },
    eventInfoSection: { marginTop: 15, paddingTop: 15, borderTopWidth: 1 },
    eventInfoRow: { flexDirection: 'row', alignItems: 'flex-start', marginBottom: 10 },
    eventInfoIcon: { marginRight: 12, marginTop: 2 },
    eventInfoText: { flex: 1 },
    eventInfoLabel: { fontSize: 12, marginBottom: 2, textTransform: 'uppercase', fontWeight: '600' },
    eventInfoValue: { fontSize: 16, fontWeight: '500' },
    participantNameRow: { flexDirection: 'row', alignItems: 'center' },

    // Tabs
    tabBar: { flexDirection: 'row', borderBottomWidth: 1 },
    tabButton: { flex: 1, paddingVertical: 15, alignItems: 'center', position: 'relative' },
    tabButtonActive: {},
    tabButtonText: { fontSize: 14, fontWeight: '600' },
    tabIndicator: { position: 'absolute', bottom: 0, left: 0, right: 0, height: 3 },

    // Tab Content
    tabContainer: { flex: 1, padding: 15 },
    tabHeader: { marginBottom: 15 },
    centerContent: { justifyContent: 'center', alignItems: 'center' },
    listContent: { flexGrow: 1, paddingBottom: 20 },

    // Participants
    addParticipantSection: { marginBottom: 15 },
    addParticipantRow: { flexDirection: 'row', gap: 10, marginBottom: 10 },
    input: { flex: 1, borderWidth: 1, borderRadius: 10, padding: 12, fontSize: 16 },
    addButton: { width: 50, borderRadius: 10, justifyContent: 'center', alignItems: 'center' },
    addButtonText: { color: '#fff', fontSize: 28, fontWeight: 'bold' },
    addRegisteredBtn: { borderWidth: 1, padding: 12, borderRadius: 8, alignItems: 'center' },
    addRegisteredBtnText: { fontSize: 14, fontWeight: '600' },
    warningBox: { padding: 12, borderRadius: 8, marginBottom: 15, borderWidth: 1 },
    warningText: { fontSize: 14 },
    participantItem: {
      padding: 15,
      borderRadius: 10,
      marginBottom: 10,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderWidth: 1,
    },
    participantInfo: { flexDirection: 'row', alignItems: 'center', flex: 1 },
    seedBadge: {
      color: '#fff',
      paddingHorizontal: 10,
      paddingVertical: 5,
      borderRadius: 12,
      fontWeight: 'bold',
      fontSize: 12,
      marginRight: 12,
    },
    participantDetails: { flex: 1 },
    participantName: { fontSize: 16, fontWeight: '500' },
    participantEmail: { fontSize: 12, marginTop: 2 },
    deleteButton: { width: 30, height: 30, borderRadius: 15, justifyContent: 'center', alignItems: 'center' },
    // Admins
    addAdminBtn: { paddingHorizontal: 15, paddingVertical: 12, borderRadius: 8, alignItems: 'center' },
    addAdminBtnText: { fontSize: 14, fontWeight: '600' },
    adminItem: {
      padding: 15,
      borderRadius: 10,
      marginBottom: 10,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderWidth: 1,
    },
    adminInfo: { flex: 1 },
    adminEmail: { fontSize: 16, fontWeight: '500', marginBottom: 4 },
    adminRole: { fontSize: 12, textTransform: 'uppercase' },
    removeAdminButton: { width: 30, height: 30, borderRadius: 15, justifyContent: 'center', alignItems: 'center' },
    removeAdminButtonText: { color: '#fff', fontSize: 18, fontWeight: 'bold' },

    // Settings
    settingsContent: { paddingBottom: 40 },
    settingsCard: { padding: 15, borderRadius: 10, marginBottom: 15, borderWidth: 1 },
    settingsLabel: { fontSize: 12, fontWeight: '600', marginBottom: 6, textTransform: 'uppercase' },
    settingsValue: { fontSize: 16 },
    actionButton: { padding: 15, borderRadius: 10, alignItems: 'center', marginTop: 10 },
    actionButtonText: { fontSize: 16, fontWeight: '600' },
    settingRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
    settingInfo: { flex: 1, marginRight: 15 },
    settingDescription: { fontSize: 12, marginTop: 4 },
    linkContainer: { padding: 12, borderRadius: 8, marginVertical: 10 },
    linkText: { fontSize: 14, fontWeight: '500' },
    copyButton: {
      padding: 12,
      borderRadius: 8,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: 10,
    },
    copyButtonText: { fontSize: 14, fontWeight: '600' },
    shareInviteButton: {
      padding: 15,
      borderRadius: 10,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    shareInviteButtonText: { fontSize: 16, fontWeight: '600' },
    tournamentTypeRow: { flexDirection: 'row', alignItems: 'center', gap: 6 },
    tournamentTypeText: { fontSize: 14 },
    map: { width: '100%', height: 250, borderRadius: 10, marginVertical: 10 },
    mapHelper: { fontSize: 12, textAlign: 'center', marginBottom: 10 },
    openMapsButton: {
      padding: 12,
      borderRadius: 8,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    openMapsButtonText: { fontSize: 14, fontWeight: '600' },
    editButton: { alignSelf: 'flex-start' },
    editButtonText: { fontSize: 14, fontWeight: '600' },

    // Rules
    rulesInput: { borderWidth: 1, borderRadius: 10, padding: 15, fontSize: 16, minHeight: 300, marginBottom: 15 },
    rulesButtons: { flexDirection: 'row', gap: 10, marginBottom: 20 },
    rulesSaveButton: { flex: 1, padding: 15, borderRadius: 10, alignItems: 'center' },
    rulesCancelButton: { flex: 1, padding: 15, borderRadius: 10, alignItems: 'center', borderWidth: 1 },
    rulesButtonText: { fontSize: 16, fontWeight: '600' },
    rulesDisplay: { padding: 20, borderRadius: 10, borderWidth: 1, marginBottom: 20, minHeight: 150 },
    rulesText: { fontSize: 16, lineHeight: 24 },
    noRulesContainer: { alignItems: 'center', paddingVertical: 60 },
    noRulesText: { fontSize: 18, fontWeight: '600', marginBottom: 8, textAlign: 'center' },
    noRulesSubtext: { fontSize: 14, textAlign: 'center', paddingHorizontal: 20 },
    editRulesButton: { padding: 15, borderRadius: 10, alignItems: 'center' },
    editRulesButtonText: { fontSize: 16, fontWeight: '600' },

    // Bottom actions
    bottomActions: { padding: 15, marginHorizontal: -15, borderTopWidth: 1 },
    startButton: { padding: 18, borderRadius: 10, alignItems: 'center' },
    startButtonText: { fontSize: 16, fontWeight: 'bold' },
    viewBracketButton: { padding: 18, borderRadius: 10, alignItems: 'center' },
    viewBracketButtonText: { fontSize: 16, fontWeight: 'bold' },

    // Modals
    modalOverlay: { flex: 1, justifyContent: 'center', alignItems: 'center' },
    addAdminModal: { borderRadius: 12, padding: 20, width: '85%', maxWidth: 400 },
    addAdminModalTitle: { fontSize: 20, fontWeight: 'bold', marginBottom: 15 },
    addAdminModalLabel: { fontSize: 14, marginBottom: 15, lineHeight: 20 },
    addAdminInput: { borderWidth: 1, borderRadius: 8, padding: 12, fontSize: 16, marginBottom: 15 },
    addAdminModalBtn: { padding: 15, borderRadius: 8, alignItems: 'center', marginBottom: 10 },
    addAdminModalBtnText: { fontSize: 16, fontWeight: '600' },
    addAdminModalCancelBtn: { padding: 15, alignItems: 'center' },
    addAdminModalCancelBtnText: { fontSize: 16 },
    roleSelector: { marginBottom: 15 },
    roleOption: { borderWidth: 1, borderRadius: 8, padding: 12, marginBottom: 10 },
    roleOptionTitle: { fontSize: 16, fontWeight: '600', marginBottom: 4 },
    roleOptionDesc: { fontSize: 13 },
    errorText: { fontSize: 18 },

    // Invite code
    inviteCodeDisplay: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 16,
      borderRadius: 8,
      marginBottom: 12,
    },
    inviteCodeText: {
      fontSize: 24,
      fontWeight: 'bold',
      letterSpacing: 4,
      textAlign: 'center',
    },
    inviteCodeActions: {
      flexDirection: 'row',
      gap: 10,
    },
    inviteCodeButton: {
      flex: 1,
      padding: 12,
      borderRadius: 8,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    inviteCodeButtonText: {
      fontSize: 14,
      fontWeight: '600',
      marginLeft: 6,
    },

    // Participant search modal
    participantSearchSelected: {
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
      borderRadius: 8,
      padding: 12,
      marginBottom: 15,
    },
    participantSearchResults: {
      borderWidth: 1,
      borderRadius: 8,
      maxHeight: 180,
      marginBottom: 15,
    },
    participantSearchResultItem: {
      padding: 12,
      borderBottomWidth: 1,
    },

    // Invite modal
    inviteModalMessage: {
      borderWidth: 1,
      borderRadius: 8,
      padding: 12,
      fontSize: 16,
      minHeight: 80,
      marginBottom: 15,
      textAlignVertical: 'top',
    },
  });
